import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Users',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Users',
        href: '/adm/conf/users',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: '',
    sortDesc: false,
    fields: [
      {
        key: 'name',
        label: 'Name',
        sortable: true,
      },
      {
        key: 'email',
        label: 'Email',
        sortable: true,
      },
      {
        key: 'company',
        label: 'Company',
        sortable: true,
      },
      {
        key: 'location',
        label: 'Location',
        sortable: true,
      },
      {
        key: 'role',
        label: 'Role',
        sortable: true,
      },
      {
        key: 'status_user',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_choose: [
      {
        key: 'name',
        label: 'Name',
        sortable: true,
      },
      {
        key: 'email',
        label: 'Email',
        sortable: true,
      },
      {
        key: 'company',
        label: 'Company',
        sortable: true,
      },
      {
        key: 'location',
        label: 'Location',
        sortable: true,
      },
      {
        key: 'role',
        label: 'Role',
        sortable: true,
      },
      {
        key: 'status_user',
        label: 'Status',
      },
    ],
    detail: false,
    form: {
      id_company: '',
      name: '',
      phone: '',
      email: '',
      password: '',
      role: 'user',
      status_user: '1',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeUser(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchUser(context, params = null) {
    let result = await ApiGetRequest(`conf/users`, params);
    return !result.error ? result.data.object : [];
  },

  async getListCompany({ commit }) {
    commit('changeUser', {
      loading: true,
    });

    let result = await ApiGetRequest(`conf/company`);
    commit('changeUser', {
      company: result.error ? [] : result.data.object,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListUser({ commit, state }) {
    commit('changeUser', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`conf/users`, params);
    commit('changeUser', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailUser({ commit }, payload = null) {
    commit('changeUser', {
      loading: true,
    });

    let result = await ApiGetRequest(`conf/users/${payload.id}`);
    commit('changeUser', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async createUser({ commit, state, dispatch }) {
    commit('changeUser', {
      loading: true,
    });

    let result = await ApiPostRequest(`conf/users`, state.data.form);
    commit('changeUser', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateUser({ commit, state, dispatch }, payload = null) {
    commit('changeUser', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `conf/users/${payload.id}`,
      state.data.form
    );

    commit('changeUser', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteUser({ commit, dispatch }, payload = null) {
    commit('changeUser', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`conf/users/${payload.id}`);
    commit('changeUser', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
